import IAuth from './index'
import GatewayBase from '../gatewayBase'
import { UserError } from '../errors'

export default class AuthNats extends IAuth {

    constructor(gateway) {
        super()
        /** @type {GatewayBase} */
        this.gateway = gateway
    }

    async login(login, password) {
        this.gateway.setToken(null)
        try {
            let result = await this.gateway.serverHttp("POST",'carabi-auth/password',{ login, password })
            return result.token
        } catch (e) {
            //Костыль для экрана авториза
            if (["InvalidLoginOrPassword","AuthError"].includes(e.name)) throw new UserError(e.message)
            throw e
        }
    }

    async logout(token) {
        await this.gateway.serverHttp("POST",'auth/logout',{})
    }

    async changeRole(employeeId, roleId, configuratorMode) {
        await this.gateway.serverHttp("POST",'carabi-auth/change-role',{
            employeeId,
            roleId,
            configuratorMode
        })
    }

}